import React from 'react'
import styled from 'styled-components'
import { formatBRL } from '../../../../cash-register/common/formatBRL'
import ProgressBar from '../../../../molecules/ProgressBar/ProgressBar'
import InfoRow from '../../../../molecules/Row/InfoRow'
import { blue, green } from '../../../../ui/utils/_colors'

interface TransactionalCreditProgressBarProps {
  recurrenceAvailableLimit: number
  evaluationMaxAmount?: number
}

const recurringLimitInfotip = 'Limite recorrente é o limite disponível que o cliente possui e pode usar nos varejos parceiros da Ume.'
const availableSuperPurchaseLimitInfotip = 'O Super Compra é um limite extra exclusivo que pode ser utilizado em uma única compra na sua loja até a data de validade indicada.'
const noSuperPurchaseLimitAvailableInfotip = 'Não foi possível aprovar um limite extra para esse cliente.'

const TransactionalCreditProgressBar: React.FC<TransactionalCreditProgressBarProps> = ({ recurrenceAvailableLimit, evaluationMaxAmount }) => {
  const evaluationLimit = evaluationMaxAmount ?? 0

  const superPurchaseInfotip = evaluationLimit ? availableSuperPurchaseLimitInfotip : noSuperPurchaseLimitAvailableInfotip

  return (
    <MainContainer>
      <ProgressBar
        primaryBar={{ value: recurrenceAvailableLimit, title: formatBRL(recurrenceAvailableLimit), color: green.confirmation }}
        secondaryBar={{ value: evaluationLimit, title: formatBRL(evaluationLimit), color: blue.cobalt }}
      />

      <InfoRow color={green.confirmation} title={'Limite recorrente'} infotip={recurringLimitInfotip} value={formatBRL(recurrenceAvailableLimit)} subtitle={'Limite disponível do cliente'} />
      <InfoRow color={blue.cobalt} title={'Limite extra aprovado'} infotip={superPurchaseInfotip} value={formatBRL(evaluationLimit)} subtitle={'Limite válido para uma única compra nesta loja'} />
    </MainContainer>
  )
}

export default TransactionalCreditProgressBar

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  text-align: left;
`
